import React, { useContext } from 'react';
import { OrderContext } from '../contexts/OrderContext'
import './Rastreio.css'

export default function Rastreio() {
  const order = useContext(OrderContext).order

  return (

    <section id="rastreio-pedidos" className="track-pack">
      <div className="track">
        <div className="endereco">
          <div className="address-informs">
            <h1>Endereço</h1>
            <hr />
            <p><strong>Rua:</strong> {order.shippingData.selectedAddresses[0].street}</p>
            <p><strong>Número:</strong> {order.shippingData.selectedAddresses[0].number}</p>
            <p><strong>Cep:  </strong>{order.shippingData.selectedAddresses[0].postalCode}</p>
            <p><strong>Bairro:</strong> {order.shippingData.selectedAddresses[0].neighborhood}</p>
            <p><strong>Estado:</strong> {order.shippingData.selectedAddresses[0].city} &nbsp;/ {order.shippingData.selectedAddresses[0].state}</p>
          </div>
        </div>

        <div className="entrega">
          <div className="track-informs">
            <h1>Entrega</h1>
            <hr />
            <p><strong>Transporte:</strong>  {order.shippingData.logisticsInfo[0].deliveryIds[0].courierName}</p>
            <p><strong>Código: </strong>  {order.shippingData.logisticsInfo[0].addressId}</p>
          </div>
        </div>
      </div>
    </section>
  )
}